import { TRoles } from '$services/types'
import { create } from 'zustand'

type TAppListStore = {
  userRoles: TRoles[]
  selectedRoles: TRoles[]
  roles: TRoles[]
  setUserRoles: (v: TRoles[]) => void
  addRoles: (v: TRoles[]) => void
  setSelectedRoles: (v: TRoles[]) => void
  deleteUserRole: (v: TRoles) => void
  removeRole: (v: TRoles) => void
  removeRoleList: (v: TRoles[]) => void
  reset: () => void
  resetUserRoles: () => void
}

export const useAssignRoleStore = create<TAppListStore>()(set => ({
  userRoles: [],
  selectedRoles: [],
  roles: [],
  setUserRoles: userRole =>
    set(state => ({
      userRoles: [...state.userRoles, ...userRole]
    })),
  addRoles: role =>
    set(state => ({
      roles: [...state.roles, ...role]
    })),
  setSelectedRoles: selectedRole =>
    set(state => ({
      selectedRoles: [...state.selectedRoles, ...selectedRole]
    })),
  deleteUserRole: userRole =>
    set(state => ({
      userRoles: state.userRoles.filter(d => d.id !== userRole.id)
    })),
  removeRole: role =>
    set(state => ({
      roles: state.roles.filter(d => d.id !== role.id)
    })),
  removeRoleList: roleList =>
    set(state => ({
      roles: state.roles.filter(d => !roleList.some(v => v.id === d.id))
    })),
  resetUserRoles: () =>
    set(() => ({
      userRoles: []
    })),
  reset: () => {
    set(() => ({
      roles: [],
      userRoles: [],
      selectedRoles: []
    }))
  }
}))
